import { useEffect } from "react"

export default function useCheckOnline() {
  useEffect(() => {
    const onlineCheck = () => {
      if (!navigator.onLine) {
        alert(
          "네트워크 연결이 해제되었습니다. 새로고침 버튼을 클릭하여 다시 접속해주시기 바랍니다.",
        )
      }
    }

    window.addEventListener("online", onlineCheck)
    window.addEventListener("offline", onlineCheck)

    return () => {
      window.removeEventListener("online", onlineCheck)
      window.removeEventListener("offline", onlineCheck)
    }
  }, [])
}
